
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const lcpq4040: IProductData = {
  id: "miad-lcpq-4040",
  name: "Miad Audio LCPQ 4040",
  description: "4 Band Inductor EQ",
  specialOrder: true,
  images: ["/img/miad_lcpq4040_front.jpg","/img/miad_lcpq4040_back.jpg", "/img/miad_lcpq4040_inside.jpg"],
  details: [{
    label: "Description",
    markdown: `
Also available in [stereo](https://audio500.com/products/miad-lcpq-4040-stereo).
Or [without psu](https://audio500.com/products/miad-lcpq-4040-wo-psu).

The LCPQ 4040 MK2 is a 4-Band inductor-based equalizer that combines the characteristics of a high-performance discrete (transistor) circuitry with the musicality that passive RLC filters are known for.

Each unit is hand-built and all the components are chosen and tested thoroughly for best performance, musicality and long-term reliability.

The LCPQ 4040 MK2 builds upon the strengths of the original LCPQ 4040, introducing a range of thoughtful updates and enhancements, while maintaining the signature sound and musicality of the original design.

The MK2 version incorporates new features and greater versatility, making it an even more powerful tool for audio professionals and enthusiasts.
`
  }, {
    label: "What's New",
    markdown: `
- Custom-made Detent Potentiometers
- Selectable Level Range
- Per-Band Level Adjustment
- Dual function of “Hi-Q” Button
- New Enclosure
- New Circuit Boards
`
  }, {
    label: "Frequency Points",
    markdown: `
- BAND 1: (Shelv. /Bell): OFF, 45Hz, 65Hz, 100Hz, 180Hz, 330Hz, 470Hz
- BAND 2: (Hi-Q/ LowQ): OFF, 180Hz, 220Hz, 270Hz, 330Hz, 390Hz, 470Hz, 560Hz, 680Hz, 820Hz, 1kHz, 1.3kHz
- BAND 3: (Hi-Q/ LowQ): OFF, 1.2kHz, 1.5kHz, 1.8kHz, 2.2kHz, 2.7kHz, 3.3kHz, 3.9kHz, 4.7kHz, 5.6kHz, 6.8kHz, 8.2kHz
- BAND 4: (Shelv. /Bell): OFF, 3.3kHz, 4.7kHz, 6.8kHz, 10kHz, 15kHz, 23kHz
`
  }, {
    label: "Technical Specs",
    markdown: `
• Frequency Response: 20Hz – 20kHz, +0/ -0.2dB
• THD+N: Less than 0.006%, +4dbu, 20Hz – 22kHz, unity gain, 22kHz BW
• Signal-to-Noise Ratio (SNR): <92dB (A-weighted) re +4dbu, 22kHz BW, unity gain
• Maximum Output Level: +24dbu
• Input: Transformer Balanced XLR (1.Chassis, 2.Signal +, 3. Signal -)
• Output: Transformer Balanced XLR (1.Chassis, 2.Signal +, 3. Signal -)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.miadaudio.com/pdf/LCPQ4040_MK2_v1.pdf" target="_blank">Operator's Manual</a>
- <a to="https://www.miadaudio.com/productregistration/" target="_blank">Product Registration</a>
- <a to="https://www.miadaudio.com/pdf/LCPQ4040MK2_RecallSheet.pdf" target="_blank">Recall Sheet</a>
- <a to="https://www.miadaudio.com/lcpq4040mk2/" target="_blank">https://www.miadaudio.com/lcpq4040mk2/</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.EQ, HASHTAGS.MIXING, HASHTAGS.RECORDING, HASHTAGS.ONE_U, HASHTAGS.LIVE_SOUND, HASHTAGS.RACK, HASHTAGS.MASTERING],
    manufacturer: BRAND.MIAD,
  }
}